/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import '@live/css/hamburgers/hamburgers.scss';

import Vue from 'vue';
import Live from './Live.vue';
import store from './store';
import i18n from './common/i18n'
import fullscreen from 'vue-fullscreen'
import VModal from 'vue-js-modal/dist/index.nocss.js'
import VueMobileDetection from "vue-mobile-detection";
import Notifications from 'vue-notification'
import Vue2TouchEvents from 'vue2-touch-events'
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

Vue.use(fullscreen)
Vue.use(VModal)
Vue.use(VueMobileDetection)
Vue.use(Notifications)
Vue.use(Vue2TouchEvents, {
    touchClass: 'hold',
    touchHoldTolerance: 1000
})

import VueCircleSlider from 'vue-circle-slider'
Vue.use(VueCircleSlider)

import titleMixin from './mixins/titleMixin'
Vue.mixin(titleMixin)

/*
import MarqueeText from 'vue-marquee-text-component'
Vue.component('marquee-text', MarqueeText)
*/

import VueCountdownTimer from 'vuejs-countdown-timer';
Vue.use(VueCountdownTimer);

Vue.component('live', require('./Live').default);
Vue.component('money-format', require('vue-money-format').default);
Vue.component('main-image', require('./components/global/MainImage').default);

Sentry.init({
    Vue,
    dsn: "https://4c8d6407ca564879a8e4f492bfc3928f@o439514.ingest.sentry.io/6564238",
    integrations: [
        new BrowserTracing({
            //routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracingOrigins: ["a10.test", "artmark.ro", /^\//],
        }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
});

window.vm = new Vue({
    i18n,
    store,
}).$mount('#app');
